import React from 'react';

import Icon from '../Icon/Icon';

const RestartDeviceRestrictedIcon = (props) => {
    return (
        <Icon width='48' height='48' fill='none' {...props}>
            <path
                d='m36.891 11.914-.003-.002c-.213-.214-.543-.437-.988-.437-.338 0-.563.117-.87.321l-.01.007-.008.009c-.214.213-.337.443-.337.688 0 .166.028.31.1.456.072.142.183.279.337.432 1.39 1.39 2.578 3.076 3.27 4.955l.003.006a14.698 14.698 0 0 1 1.19 5.851c0 4.268-1.488 7.936-4.463 10.912-2.976 2.975-6.644 4.463-10.912 4.463-4.268 0-7.936-1.488-10.912-4.463-2.976-2.976-4.463-6.644-4.463-10.912 0-2.082.396-3.966 1.19-5.85.794-1.788 1.885-3.473 3.37-4.859l.003-.003c.221-.22.33-.545.425-.833l.006-.015.006-.02v-.035c0-.275 0-.512-.204-.739a.376.376 0 0 0-.197-.28.865.865 0 0 0-.424-.091c-.21 0-.377.026-.521.084-.146.058-.26.145-.367.253a18.038 18.038 0 0 0-3.827 5.639c-.906 2.114-1.41 4.33-1.41 6.649 0 2.417.504 4.734 1.41 6.85a17.865 17.865 0 0 0 3.727 5.538c1.611 1.612 3.425 2.82 5.539 3.727a17.355 17.355 0 0 0 6.849 1.41c2.418 0 4.734-.504 6.85-1.41a17.865 17.865 0 0 0 5.538-3.727c1.612-1.611 2.82-3.425 3.727-5.539a17.355 17.355 0 0 0 1.41-6.849c0-2.316-.403-4.433-1.31-6.55-.906-2.113-2.114-3.926-3.724-5.636z'
                fill='#232029'
                stroke='#232029'
                strokeWidth='.25'
            />
            <path
                d='M24.5 6.175c-.165 0-.307.028-.438.086-.13.058-.243.143-.35.25-.108.108-.193.22-.251.35-.058.132-.086.274-.086.439v17.2c0 .165.028.307.086.438.058.13.143.243.25.35.226.226.534.337.827.337.288 0 .577-.11.756-.343.105-.105.188-.216.245-.344.058-.13.086-.273.086-.438V7.3c0-.165-.028-.307-.086-.438a1.162 1.162 0 0 0-.25-.35 1.164 1.164 0 0 0-.35-.251 1.057 1.057 0 0 0-.439-.086z'
                fill='#00D1D2'
                stroke='#00D1D2'
                strokeWidth='.25'
            />
        </Icon>
    );
};

export default RestartDeviceRestrictedIcon;
